module.exports = __webpack_public_path__ + "img/axle_conf_9.18710ebd.jpg";